import {ButtonCard, TitleCardLoginWrap} from "./CardLogin.styles";
import {Box} from "@mui/material";
import usePasswordHook from "../../../../_fri/hooks/usePasswordHook";
import {useCredentialsMutation} from "../../../../store/api/service/auth";
import {SubmitHandler, useForm} from "react-hook-form";
import {Login, schemaLogin} from "../core/_model";
import {yupResolver} from "@hookform/resolvers/yup";
import {EyePassword} from "../../../../_fri/components/CustomEyePassword";
import {CredentialRequest} from "../../../../store/api/interface/auth";
import {TextSpinner} from "../../../../_fri/components/CustomTextSpinner";
import {Module, useCleanMessageHook} from "../../../../_fri/hooks/useCleanMessageHook";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store/store";
import {CardHeader} from "./CardHeader";
import {CustomInput} from "../../../../_fri/components/CustomInput";
import CustomAlertSuccess from "../../../../_fri/components/CustomAlert/CustomAlertSuccess";
import CustomAlertDanger from "../../../../_fri/components/CustomAlert/CustomAlertDanger";
import {deleteLocalStorage, getLocalStorage, setLocalStorage} from "../../../../_fri/utils/function";
import {KeyLocalStorage} from "../../../../_fri/utils/enum";

export const CardLogin = () => {

    const [togglePassword, showPassword] = usePasswordHook();
    const [credential, credentialStatus] = useCredentialsMutation();
    const cleanMessage = useCleanMessageHook(Module.login);
    const successMessage = useSelector((state: RootState) => state.message.successMessage);
    const errorMessage = useSelector((state: RootState) => state.message.errorMessage);
    const userRememberStorage = getLocalStorage(KeyLocalStorage.REMEMBERED);
    const userRemember = (userRememberStorage === null || userRememberStorage === undefined) ? "" : userRememberStorage;

    const formLogin = useForm<Login>({
        resolver: yupResolver(schemaLogin), defaultValues: {username: userRemember, remember: userRemember!==""}
    });

    const onSubmit: SubmitHandler<Login> = (value) => {

        if (value.remember) {
            setLocalStorage(KeyLocalStorage.REMEMBERED, value.username);
        }else{
            deleteLocalStorage(KeyLocalStorage.REMEMBERED)
        }

        const data: CredentialRequest = {
            username: value.username,
            password: value.password
        };

        credential(data);
    };


    return (
        <Box>
            <CardHeader/>

            <TitleCardLoginWrap sx={{paddingBottom: "1.875rem"}}>
                Inicio de sesión
            </TitleCardLoginWrap>

            <form onSubmit={formLogin.handleSubmit(onSubmit)}>

                <Box sx={{marginTop: "1.875rem"}}>
                    <CustomInput
                        {...formLogin.register("username")}
                        label="Usuario"
                        variant="filled"
                        InputProps={{disableUnderline: true}}
                    />
                </Box>
                <Box sx={{marginTop: "1rem", marginBottom: "0.938rem"}}>
                    <CustomInput
                        {...formLogin.register("password")}
                        label="Contraseña"
                        variant="filled"
                        type={showPassword ? "text" : "password"}
                        InputProps={{
                            endAdornment: (
                                <EyePassword show={showPassword} toggle={togglePassword}/>
                            ),
                            disableUnderline: true
                        }}
                    />

                </Box>


                <CustomAlertDanger text={errorMessage || ""} show={errorMessage !== undefined}/>

                <CustomAlertSuccess text={successMessage || ""} show={successMessage !== undefined}/>


                <Box sx={{marginTop: "1.25rem"}}>
                    <ButtonCard
                        variant="contained"
                        type={"submit"}
                        disabled={credentialStatus.isLoading || (!formLogin.formState.isValid)}
                    >
                        <TextSpinner isLoading={credentialStatus.isLoading}
                                     text={"Iniciar sesión"}
                                     textSpinner={"Cargando"}
                        />
                    </ButtonCard>
                </Box>
            </form>


        </Box>
    );
};